import RequestCallbackForm from "@components/forms/RequestCallbackForm"
import CloseIcon from "@components/icons/CloseIcon"
import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import "./PopupForms.scss"

const RequestCallbackModal = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="popup-form-modal"
    >
      <Modal.Body className="popup-form-modal-body">
        <div className="popup-form-modal-content">
          <CloseIcon onClick={handleClose} color="secondary" />
          <div className="content-section">
            <h2>
              <i>Request</i> a Callback
            </h2>
            <p>
              Please leave your details below and one of our local team will be
              in touch to assist you.
            </p>
          </div>
          <RequestCallbackForm />
        </div>
      </Modal.Body>
    </Modal>
  )
}

export const RequestCallbackModalWithTrigger = ({
  buttonText,
  children,
  className,
  cta_label,
}) => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  return (
    <>
      <button className={className} onClick={handleShow}>
        {children || buttonText ? (
          <span>{buttonText}</span>
        ) : (
          <span>{cta_label}</span>
        )}
      </button>
      <RequestCallbackModal show={show} handleClose={handleClose} />
    </>
  )
}

export default RequestCallbackModal
